export default "__VITE_ASSET__QXUK3sum__"